import BackgroundGradient from 'components/elements/backgrounds/BackgroundGradient'
import React from 'react'
import GlobalHeaderArea from '../RequestTemplate/GlobalHeaderArea'

/**
 * InformationAreaのタイプ定義
 */
export type InformationAreaProps = {
  /** コンテンツ */
  content: React.ReactNode
}

/**
 * 対象がInformationAreaProps型かチェックする
 * @param target チェック対象
 */
export const isInformationAreaProps = (
  target: any
): target is InformationAreaProps => {
  return target.content !== undefined
}

/**
 * 要請後画面の情報表示エリア
 */
const InformationArea: React.FC<InformationAreaProps> = (props) => {
  const { content } = props
  return (
    <BackgroundGradient>
      <GlobalHeaderArea />
      {content}
    </BackgroundGradient>
  )
}

export default InformationArea
